// eslint-disable-next-line id-length
export const removeClassesFromElement = (element, classes, fn = null) => {
    element.classList.remove(typeof fn === 'function' ? fn(classes) : classes);
};

// eslint-disable-next-line id-length
export const addClassesToElement = (element, classes, fn = null) => {
    element.classList.add(typeof fn === 'function' ? fn(classes) : classes);
};

/**
 * @description Set `className` to a `target` after remove `className` in element find in `wrapper.
 * @param {HTMLElement} domTarget - The target.
 * @param {HTMLElement} domWrapper - The wrapper.
 * @param {string} className - The class name to change.
 */
export const setUniqueClassName = (domTarget, domWrapper, className) => {
    if(domWrapper) {
        const DOMCurrentClassName = domWrapper.querySelector(`.${className}`);
        if(DOMCurrentClassName) {
            removeClassesFromElement(DOMCurrentClassName, className);
        }
        if(domTarget) {
            addClassesToElement(domTarget, className);
        }
    }
};
